const { resolveAssetUrl } = require("./assetUrl.cjs");

const updateBasicDataAvatar = (basicData = {}, head, baseURL = "", defaultAvatar = "") => {
    const headReference = typeof head === "string" ? head.trim() : "";
    return {
        ...(basicData || {}),
        head_reference: headReference,
        head: resolveAssetUrl(headReference, baseURL, defaultAvatar),
    };
};

module.exports = { updateBasicDataAvatar };
